// frontend/src/components/notifications/NotificationDropdown.js
import { useNotifications } from '../../context/NotificationContext';
import NotificationItem from './NotificationItem';
import styles from './NotificationDropdown.module.css';

const NotificationDropdown = ({ onClose }) => {
  const { notifications, unreadCount, markAllRead } = useNotifications();

  return (
    <div className={styles.dropdown}>
      <div className={styles.header}>
        <span className={styles.heading}>Notifications</span>
        {unreadCount > 0 && (
          <button className={styles.markAll} onClick={markAllRead}>
            Mark all read
          </button>
        )}
      </div>

      <div className={styles.list}>
        {notifications.length === 0 ? (
          <div className={styles.empty}>No notifications yet</div>
        ) : (
          notifications.map((n) => (
            <NotificationItem key={n.id} notification={n} onClose={onClose} />
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationDropdown;
